/* Domovoi · a quiet note while the device is offline (D1.1).

   With the service worker, pages and your last-loaded lists still open with no
   signal. One short line so it doesn't cover the list you're shopping from;
   taps pass through it. */
var STYLE = '.dv-offline{position:fixed;left:50%;bottom:calc(16px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)));transform:translateX(-50%);' +
  'z-index:9999;max-width:calc(100% - 32px);box-sizing:border-box;padding:7px 14px;border-radius:999px;' +
  'background:#1A0A2E;color:#FCF0E3;font:600 12px/1.3 "DM Sans",system-ui,sans-serif;text-align:center;white-space:nowrap;' +
  'box-shadow:0 6px 20px rgba(26,10,46,.25);pointer-events:none}';

var el = null;
// A product showing what it saved last time can say how old it is (Considered's calendar, V4):
// window.dispatchEvent(new CustomEvent('dv-offline-as-of', { detail: 'As of 8:14 this morning' })), null to drop it.
var asOf = null;
// A screen saying it itself (Catered's shop: "No signal. Your ticks are kept…") hides the note while it's open:
// window.dispatchEvent(new CustomEvent('dv-offline-quiet', { detail: true })), false when it closes.
var quiet = false;
function text() { return asOf ? "You're offline. " + asOf + '.' : "You're offline. Changes won't save."; }

function show() {
  if (el) return;
  if (!document.getElementById('dv-offline-style')) {
    var s = document.createElement('style'); s.id = 'dv-offline-style'; s.textContent = STYLE;
    document.head.appendChild(s);
  }
  el = document.createElement('div');
  el.className = 'dv-offline';
  el.setAttribute('role', 'status');
  el.textContent = text();
  document.body.appendChild(el);
}

function hide() { if (el) { el.remove(); el = null; } }

function check() { if (navigator.onLine === false && !quiet) show(); else hide(); }

if (typeof window !== 'undefined') {
  window.addEventListener('offline', check);
  window.addEventListener('online', hide);
  window.addEventListener('dv-offline-quiet', function (e) { quiet = !!(e && e.detail); check(); });
  window.addEventListener('dv-offline-as-of', function (e) { asOf = (e && e.detail) || null; if (el) el.textContent = text(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
}
